export enum Scope {
    // ----- Non REST Scopes ------- //

    // Default BE-FE-Scopes
    Default = 'default',
    All = 'all',
    Admin = 'admin',
    ListDashboard = 'get.dashboard',

    // ----- REST Scopes ------- //

    // List Scopes
    ListScopes = 'get.scopes',
    ListCompanies = 'get.companies',
    ListEmployees = 'get.employees',
    ListUsers = 'get.users',
    ListUser = 'get.user',
    ListUserProfile = 'get.user.profile',
    ListUserRoles = 'get.user.roles',
    ListUserRole = 'get.user.role',
    ListUserByCompany = 'get.user.company',
    ListUserRolesByCompany = 'get.user.role.company',
    ListOwnCompany = 'get.company.own',
    ListCompanyLocks = 'get.company.locks',
    ListInformation = 'get.open-house',
    ListILockIt = 'get.ilockit',
    ListVecos = 'get.vecos',
    ListOwnCompanyQrCodes = 'get.qrcode.own',

    // Delete Scopes
    DeleteCompany = 'delete.company',
    DeleteUser = 'delete.user',
    DeleteUserRole = 'delete.user.role',
    DeleteVecos = 'delete.vecos',

    // Put Scopes
    UpdateCompany = 'put.company',
    UpdateCompanyStatus = 'put.company.status',
    UpdateUsers = 'put.users',
    UpdateUserProfile = 'put.user.profile',
    UpdateUserRole = 'put.user.role',
    UpdateUserStatus = 'put.user.status',
    UpdateOwnCompany = 'put.company.own',
    UpdateWeeklyMenu = 'put.weekly-menu',
    UpdateQrCodeStatus = 'put.qrcode.status',
    UpdateILockIt = 'put.ilockit',
    UpdateILockItStatus = 'put.ilockit.status',
    UpdateVecos = 'put.vecos',
    UpdateVecosStatus = 'put.vecos.status',

    // POST Scopes
    CreateCompany = 'post.company',
    CreateUser = 'post.user',
    CreateUserRole = 'post.user.role',
    CreateILockIt = 'post.ilockit',
    CreateVecos = 'post.vecos',

    SendMailAll = 'post.mail.all',
    SendMailCompany = 'post.mail.company',
    SendMailList = 'post.mail.list',
    SendMailUser = 'post.mail.user',

    // Helper Scopes
}
